/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Creating1Inputs */

const zh_organizationsettings_creating1 = /** @type {(inputs: Organizationsettings_Creating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建中...`)
};

const en_organizationsettings_creating1 = /** @type {(inputs: Organizationsettings_Creating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

const es_organizationsettings_creating1 = /** @type {(inputs: Organizationsettings_Creating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando...`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Organizationsettings_Creating1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_creating1 = /** @type {((inputs?: Organizationsettings_Creating1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Creating1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_creating1(inputs)
	if (locale === "en") return en_organizationsettings_creating1(inputs)
	return es_organizationsettings_creating1(inputs)
});
export { organizationsettings_creating1 as "organizationSettings_creating" }